<style scoped>
.fa-baseline {
  display: flex;
  align-items: baseline;
}
.fj-space {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.fj-start {
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
}
.container {
  display: flex;
}

.container .col-main {
  flex: 1 1 100%;
  max-width: 1150px;
  overflow-x: scroll;
}

.slider-container {
  display: inline-flex;
}

.slider-content {
  display: flex;
  flex-direction: column;
  width: 280px;
}
h3 {
  color: black;
}
.label-normal {
  color: black;
  font-size: 16px;
}
.label-person {
  color: black;
  font-size: 15px;
}
.upload-square {
  width: 100%;
  height: 200px;
  border: 1px solid rgba(0, 0, 0, 0.42);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  cursor: pointer;
}
.inline-font {
  width: 180px;
  text-align: right;
}
.disable-events {
  pointer-events: none;
}
</style>

<template>
  <div>
    <div class="mt-n8 mb-3 ml-6" style="font-size: 1.35rem" color="blue">
      <div class="fj-space">
        <div>เพิ่มบทความ</div>
        <div class="fj-space">
          <div class="mx-2">
            <v-btn color="primary" width="100%" @click="back()"> ยกเลิก </v-btn>
          </div>
          <div class="mx-2">
            <v-btn color="success" width="100%" @click="insert_content_img()">
              บันทึก
            </v-btn>
          </div>
        </div>
      </div>
      <v-divider class="mt-3"></v-divider>
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <div class="fj-start">
              <div style="width: 10%">หัวข้อ :</div>
              <div style="width: 90%">
                <v-text-field
                  class="mt-0 pt-0"
                  outlined
                  v-model="header"
                  dense
                  type="text"
                ></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="fj-space">
              <div style="width: 70%">รูปภาพ :</div>
              <div style="width: 30%">
                <v-btn
                  style="width: 100%"
                  color="success"
                  @click="di_pic = true"
                >
                  <v-icon class="mr-1">mdi-plus</v-icon> เพิ่มรูปภาพ
                </v-btn>
              </div>
            </div>
            <div class="mt-3">
              <div class="container">
                <div class="col-main">
                  <div class="slider-container">
                    <div
                      class="slider-content mb-5"
                      v-for="item in img_list"
                      :key="item.ID"
                    >
                      <v-btn
                        icon
                        class="mb-n10"
                        style="align-self: end"
                        @click="removeImg(item.ID, item.IMG)"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>

                      <v-img
                        max-height="160"
                        max-width="250"
                        :src="item.IMG_BLOB"
                      ></v-img>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-col>

          <v-col cols="12">
            <div class="fj-start">
              <div style="width: 10%">เนื้อหา :</div>
              <div style="width: 90%">
                <vue-editor
                  v-model="c_content"
                  :editorToolbar="editorSettings"
                ></vue-editor>
                <!-- <v-textarea
                  rows="10"
                  auto-grow
                  dense
                  outlined
                  v-model="c_content"
                ></v-textarea> -->
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <v-dialog v-model="di_pic" max-width="650" :retain-focus="false">
        <v-card>
          <v-card-title style="justify-content: center">
            เพิ่มรูปภาพ
          </v-card-title>

          <v-card-text>
            <v-divider class="mb-3"></v-divider>
            <v-form ref="form2" :lazy-validation="lazy">
              <v-row justify="center">
                <v-col cols="12">
                  <v-file-input
                    prepend-icon=""
                    prepend-inner-icon="mdi-paperclip"
                    label="กดเพื่ออัพโหลดรูปภาพ"
                    outlined
                    dense
                    accept="image/*"
                    @change="onSelect2"
                    class="mt-2"
                    v-model="input_img"
                    :rules="[
                      (file) => {
                        if (file) {
                          if (file.size > 4e6) {
                            return 'ไฟล์รูปภาพต้องขนาดไม่เกิน 4MB';
                          } else {
                            return true;
                          }
                        } else {
                          return true;
                          // return true;
                        }
                      },
                    ]"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import {  mapMutations } from "vuex";
export default {
  name: "RegisterSummary",
  components: {
    VueEditor
  },
  data() {
    return {
      lazy: true,
      header: "",
      c_content: "",
      img_list: [],
      input_img: null,
      c_img: null,
      di_pic: false,
      counter: 0,
      editorSettings: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ["clean"] // remove formatting button
      ]
    }
  },
  created() {

  },
  filters: {

  },
  watch: {


  },
  computed: {


  },
  methods: {
    ...mapMutations({
      LOADER: "Drawer/SET_LOADER",
      SET_USER: "Drawer/SET_USER_DEAIL",
    }),
    onSelect2(file) {
      const _this = this
      this.c_img = file
      //const formData = new FormData();
      if (file) {
        this.img_list.push({ ID: this.counter++, IMG_BLOB: URL.createObjectURL(file), FILE: this.c_img })
        //formData.append("files[]", this.c_img);
      }
      setTimeout(() => {
        _this.c_img = null
        _this.input_img = null
        _this.di_pic = false
      }, 500)
    },
    removeImg(id, img) {
      this.img_list.splice(this.img_list.findIndex(item => item.ID === id), 1)
    },
    insert_content_img() {
      this.LOADER(true);
      if (this.header == "") {
        this.$swal("เกิดข้อผิดพลาด", "กรุณากรอกหัวข้อบทความ", "warning");
        this.LOADER(false);
      } else {
        const formData = new FormData();
        this.img_list.forEach(item => {
          formData.append("files[]", item.FILE);
        })
        formData.set("CONTENT", this.c_content);
        formData.set("HEADER", this.header);
        this.$token_api
          .post("/insert-content-pic", formData)
          .then((res) => {
            console.log(res.data)
            if (res.data.data == "Upload success") {
              this.LOADER(false);
              this.$swal({
                title: "สำเร็จ",
                text: "ส่งข้อมูลสำเร็จ",
                timer: 2000,
                icon: "success",
              }).then((res) => {
                this.LOADER(false);
                // this.di_pic = false
                // this.$refs.form2.reset()
                // this.listImgContent()
                this.$router.push({ path: "/index/list-articles" })
              });
            } else {
              this.LOADER(false);
              this.$swal("เกิดข้อผิดพลาด", "กรุณาลองใหม่อีกครั้ง", "warning");
            }
          })
          .catch((e) => {
            console.log(e)
            this.LOADER(false);
            this.$swal("เกิดข้อผิดพลาด", "กรุณาลองใหม่อีกครั้ง", "warning");
          });
      }

    },
    back() {
      this.counter = 0
      this.img_list = []
      this.c_content = "",
      this.header = "",
      this.$router.push({ path: "/index/list-articles" })
    }
  },
};
</script>
